/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reconcile_Col_AccountInputs */

const vi_reconcile_col_account = /** @type {(inputs: Reconcile_Col_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài khoản`)
};

/**

* @param {Reconcile_Col_AccountInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const reconcile_col_account = /** @type {((inputs?: Reconcile_Col_AccountInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reconcile_Col_AccountInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_reconcile_col_account(inputs)
});